<template>
     <v-data-table
       :headers="headers"
       :items="turmas"

       :sort-desc="true"

       class="elevation-1"
       :search="search"
     >

       <template v-slot:top>
         <v-toolbar flat color="white">
            <v-progress-circular
                           :size="50"
                           color="green"
                           indeterminate
                            v-if="isLoading"
                         ></v-progress-circular>
           <v-btn
             to="/menu-pauta"
             class="mx-2"
             fab
             dark
             color="primary"
           >
             <v-icon dark>arrow_back</v-icon>
           </v-btn>

           <v-divider class="mx-8" inset vertical></v-divider>
           <v-toolbar-title>
             Turma(s) da
             <span v-if="idclasse === 1">10ª classe</span>
             <span v-if="idclasse === 2">11ª classe</span>
             <span v-if="idclasse === 3">12ª classe</span>
             <span v-if="idclasse === 4">13ª classe</span>
           </v-toolbar-title>
           <v-divider class="mx-8" inset vertical></v-divider>
                <span>Selecionado : <strong style="font-size:22px;">{{$store.state.novadescricaoSelecionado}}</strong></span>
           <!--  search  -->
           <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
             {{ $store.state.textMessage }}
           </div>

           <div class="flex-grow-1"></div>

           <v-text-field
             v-model="search"
             append-icon="search"
             label="Search"
             single-line
             hide-details
           ></v-text-field>
           <!-- end  search  -->

           <v-divider class="mx-4" inset vertical></v-divider>
           <v-spacer></v-spacer>
           <v-dialog v-model="dialog" max-width="500px">

             <v-card>
               <v-card-title>
                 <span class="headline">{{ formTitle }} -</span>
                 <span v-if="idclasse === 1">10ª classe</span>
                 <span v-if="idclasse === 2">11ª classe</span>
                 <span v-if="idclasse === 3">12ª classe</span>
                 <span v-if="idclasse === 4">13ª classe</span>
               </v-card-title>
               <v-card-text>
                 <v-container>
                   <v-form ref="form" v-model="formValid" lazy-validation>
                     <v-row>
                       <v-col cols="12" sm="12" md="12">
                         <div
                           v-if="$store.state.hasMessage"
                           :class="$store.state.classMessage"
                         >
                           {{ $store.state.textMessage }}
                         </div>

                         <span
                           v-if="sala && flag_curso && editedItem.periodo.value"
                           ref="myid"
                         >
                           {{
                             flag_curso
                               .trim()
                               .toUpperCase()
                               .substring(0, 3)
                               .concat("-")
                               .concat("SALA " + sala.padStart(2, "0") + "-")
                               .concat(editedItem.periodo.value + "-" + classeTur)
                           }}
                         </span>
                       </v-col>
                       <v-col cols="12" sm="12" md="12">
                         <v-combobox
                           v-model="editedItem.idCurso"

                           item-text="descricao"
                           @change="createdTurmaflag_description"
                           :items="cursos"
                           chips
                           label="Curso"
                         ></v-combobox>
                       </v-col>
                       <v-col cols="12" sm="12" md="6">
                         <v-text-field
                           :rules="notaRules"
                           v-model="sala"
                           label="Sala"
                         ></v-text-field>
                       </v-col>
                       <v-col cols="12" sm="12" md="6">
                         <v-combobox
                           v-model="editedItem.periodo"

                           item-value="value"
                           item-text="descricao"
                           :items="periodos"
                           chips
                           label="Periodo"
                         ></v-combobox>
                       </v-col>
                     </v-row>
                   </v-form>
                 </v-container>
               </v-card-text>

               <v-card-actions>
                 <v-spacer></v-spacer>
                 <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                 <v-btn
                   color="blue darken-1"
                   v-if="
                     !(formValid && sala && flag_curso && editedItem.periodo.value)
                   "
                   text
                   @click="save"
                   >Save</v-btn
                 >
               </v-card-actions>
             </v-card>
           </v-dialog>
         </v-toolbar>
       </template>
       <template v-slot:item.action="{ item }">
           <v-icon  class="mr-2" @click=" criarPdf(item) "  style="color:green">print</v-icon>

       </template>
       <template v-slot:no-data>
         no data
       </template>
     </v-data-table>
   </template>
<script>
import axios from '../../plugins/axios'
// import jsreport from 'jsreport-browser-client-dist/jsreport'
const ls = require('local-storage')
// const fs = require('fs')
// const request = require('request')
const help = require('../../../Helpers/Helpers')
export default {
  data: () => ({
    logotipo: ls.get('logotipo'),
    insignia: ls.get('insignia'),
    option: { 'format': 'A3',
      'orientation': 'landscape',
      paginationOffset: 2,
      'header': {
        'height': '10mm',
        'contents': '<div style="text-align: center;">Author: Marc Bachmann</div>' },
      'footer': {
        'height': '5mm'
      } },
    url: ``,
    text: '',
    flag_curso: '',
    formValid: true,
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    search: '',
    quant: 0,
    cursos: [],
    html: ``,
    disciplinas: [],
    notas: [],
    isLoading: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    periodos: [
      { descricao: 'Manhã', value: 'M' },
      { descricao: 'Tarde', value: 'T' }
    ],
    turmas: [],
    dialog: false,
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Acção', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    defaultItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nova Turma' : 'Editar Turma'
    },

    idclasse () {
      return this.$store.state.idclasse
    },
    classeTur () {
      return this.$store.state.classeTur
    },

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

    instituicaoId () {
      return ls.get('i_id')
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeCursos()
    this.initializeturmasAll()
    this.carregarConfiguracoesReports()
  },

  methods: {
    createdTurmaflag_description () {
      // flag_periodo:'',
      // flag_sala:

      this.flag_curso = this.editedItem.idCurso.descricao

      //  this.flag_sala = this.sala
    },

    descricaoEscola () {
      return (this.instituicaoId === 1) ? 'INSTITUTO TÉCNICO DE SAÚDE DE LUANDA' : this.instituicaodescricao.toUpperCase()
    },

    getClasseDescricao (idclasse) {
      switch (idclasse) {
        case 1:
          return '10ª Classe'
        case 2:
          return '11ª Classe'
        case 3:
          return '12ª Classe'
        case 4:
          return '13ª Classe'

        default:
          break
      }
    },
    async initializeCursos () {
      try {
        //  this.isLoading = true
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeturmasAll () {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.turmas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.turmas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
           this.turmas.splice(index, 1)
      this.EliminaTurma(item)
    },
    async EliminaTurma (item) {
      try {
        //  this.isLoading = true
        this.alunosTurma = await axios.get('/turmaFindCountPk/' + item.pkTurma).then(res => res.data)
        if (!this.alunosTurma.length) {
          this.Eliminar(item)
        } else {
          this.text = 'Está turma não pode ser eliminada'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 2000
          })
        }
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async Eliminar (item) {
      try {
        this.msg = await axios
          .get('/EliminarTurma/' + item.pkTurma)
          .then(res => res.data)

        this.text = this.msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 4000
        })
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    ListagemEstudantes (item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },
    zebraPauta (i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    async  pautasgerarpdf (options) {
      this.isLoading = true
      try {
        //    impressaopdf.createPdf(this.html, {
        //      margin: 1,
        //      filename: 'myfile.pdf',
        //      image: { type: 'jpeg', quality: 0.98 },
        //      html2canvas: { scale: 2 },
        //      jsPDF: { unit: 'mm', format: 'A3', orientation: 'landscape' },
        //      // pagebreak: { mode: 'avoid-all', before: '#page2el' }
        //      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        //    })
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: options
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        //    // Imprimir PDF

        this.isLoading = false
        //    this.frame()
      } catch (error) {
        this.isLoading = false
      }
    },
    frame () {
      this.isLoading = false
      this.url = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
         <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
         <body>
         <iframe target="_blank" type="application/pdf" src="` + this.url + `"></iframe> 
         </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },
    comporHtmlPauta4 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '12mm' },
        'footer': {
          'height': '18mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `  <tr class="` + this.zebraPauta(i) + `">
                       <td align="center" height="20">
                           ` + i + `
                       </td>
                       <td>
                            ` + element.nome + `
                       </td>
                        <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_0) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_1) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_1) + `
                       </td>  
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_2) + `
                       </td>
                        <td 
                            ` + this.isNull(element.rec_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_3) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                        
                     
                       <td class="NaoTransita" >
                        <spa class=` + (element.resultado) + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>
           `
      })
      this.html = `<html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
           .invoice-box table tr.heading td {
       background: #eee;
       border-bottom: 1px solid #ddd;
       font-weight: bold;
   }
   
                table.report-container {
         page-break-after:always;
         
   }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   thead.report-header {
         display:table-header-group;
   }
    .zebr{
           background-color: #DCDCDC;
       }
   tfoot.report-footer {
         display:table-footer-group;
   } 
               td.ex2 {
     width: 10px;
     padding:60px;
     _width: 105px;
        }
      table.ex1 {
     margin:30;
      margin-top:0;
     font-size:10px;
   }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
   .9{
        color:red
   }
       #t1 {
     -moz-tab-size: 50;
     -o-tab-size: 50;
     tab-size: 50;
   }
   pre {
     display: block;
     font-family:  "Times New Roman", Times, serif;
     white-space: pre;
   }
           </style>
       </head>
       <body>
        <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
              <span style="padding-left:90px">Visto</span><br>
          _________________________________
             <span style="padding-left:70px;">` + pautaTrimestralConfiguracoes[0].valor + `</span>
             </pre>
           
           <div align="center">
   
               <table border="0" cellpadding="0" cellspacing="0">
   
                   <tr>
   
                       <td colspan="4">
                         <center>  <img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" />
                  <br></br><center style="font-size:12px">INSTITUTO TÉCNICO PRIVADO DE SAÚDE <br>
                             ` + this.descricaoEscola() + `<br><br>
                              PAUTA FINAL DE ` + dados[0].curso + `</center>
   
                       </td>
                   </tr>
                     </table>
           </div>
           <div align="center">
           <table  style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
            <tr class="heading">
                       <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                     CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                        <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                         PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                        ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                       </td>
                   </tr>
             </table>
             </div>
               </table>
   
             <div>
   
               <table class="ex1" BORDER=1 cellspacing="0" >
               <thead class="report-header">
                  <tr class="heading">
                  <td rowspan="2" >Nº</td>
                  <td rowspan="2" class="ex2"   >Nome </td>
                  <td align="center" class="borda-limit" colspan="7" bgcolor="#DCDCDC" >` + dados[0].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"  width="60" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" class="borda-limit" colspan="7"  width="60" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"  width="60" bgcolor="#DCDCDC">` + dados[3].disciplina + `</thd>
                  <td colspan="1"  height="80" width="50"> </td>
     </tr>
       <tr   class="heading">
                        <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
   
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                     
                        <td align="center" height="40"  width="60">
                      Resultado
                       </td>        
                   </tr>
                  </thead>
                  ` + htmlDasNotas + `
                   </table>
             </div>
           <br></br>
            <footer>
   
    <table  class="ex1" BORDER=0 cellspacing="0" class="report-container" >
    <tr>
      <td>
           <span style="padding-left:20px; font-size:10px;">` + pautaTrimestralConfiguracoes[1].valor + `</span><br></br>
            <span>______________________________________________</span>
       </td>
        <td>
          <div><span style="padding-left:200px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
       </td>
        <td>
           <span style="padding-left:290px; font-size:10px;"> ` + pautaTrimestralConfiguracoes[2].valor + `</span><br></br>
           <span style="padding-left:240px;"> ________________________________________________________________________</span>
       </td>
    </tr>
             </table>
   
   </footer>
       </body>
   </html>`
      this.pautasgerarpdf(options)
    },

    comporHtmlPauta6 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '12mm' },
        'footer': {
          'height': '18mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
           <tr class="bodyText ` + this.zebraPauta(i) + `">
                       <td>
                           ` + i + `
                       </td>
                       <td style="text-align: justify;font-size: 9px;">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td> 
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
   
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = ` 
      <html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
    .zebr{ background-color: #DCDCDC;}
      td.ex2 { width:10%  }
      table.ex1 { margin: 0px 10px 10px 0px; }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
   table tr.heading td {
     text-align: center;
     font-size:7px;
     height: 10px;
     width: 1%;
}
   table tr.footer td {
     border: 0;
     text-align: center;
     font-size:12px;
}
table tr.pre td {
     text-align: center;
     font-size:10px;
}
table tr.bodyText td {
     text-align: center;
     font-size:8px;
}
table tr.cabecalho td {
     text-align: center;
     font-size:14px;
}
table tr.cabecalho2 td {
     text-align: justify;
     font-size:12px;
}
table tr.tablehead td {
     text-align: center;
     font-size:9px;
}
   .borda-limit{
     border-right-color:black;
     border-right-width: 1px;
   }
   body { font-family: Arial, Helvetica, sans-serif; }
   div { font-family: Arial, Helvetica, sans-serif; }
   table { font-family: Arial, Helvetica, sans-serif; }
           </style>
       </head>
       <body>
<div><br>
<table width="100%" BORDER=0 cellspacing="0" >
   <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
   <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral I.T.S.L</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>Francisca Manuela Manjenje Boavida</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>"Enfermeira Especialista"</td></tr>
            </table>
     <table width="100%" border="0" cellpadding="0" cellspacing="0">   
          <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
          <tr class="cabecalho"><td>INSTITUTO TÉCNICO PRIVADO DE SAÚDE</td></tr>
          <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
          <tr class="cabecalho"><td> PAUTA FINAL DE ` + dados[0].curso + `</td></tr>
     </table><br>

     <table width="100%" border="0" cellpadding="0" cellspacing="0">
            <tr class="cabecalho2">
              <td align="left">CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;</td>
              <td align="center">Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp; </td>
               <td align="center">TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u></td>
                   </tr>
             </table><br>

             <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
                
                  <tr class="tablehead">
                  <td rowspan="2" width="1%">Nº</td>
                  <td rowspan="2" class="ex2">Nome </td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[0].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[4].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                  <td width="3%"> </td>
     </tr>
     <tr class="heading">
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                     <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                        <td>
                      Resultado
                       </td>        
                   </tr>
                   ` + htmlDasNotas + `
</table><br>

   <table width="100%" cellspacing="0" >
   <tr>
     <td></td>
       <td>O(A) Cordenador(a) do Curso</td>
       <td> O(A) subdirector(a) Pedagógico(a)</td>
       <td> O(A) Director(a) da Escola </td>
       <td></td>
      <tr class="footer">
          <td></td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td></td>
          </tr>
            </table>
  </div>
      </body>
  </html>`
      this.pautasgerarpdf(options)
    },

    comporHtmlPauta8 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '8mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
           <tr class="bodyText ` + this.zebraPauta(i) + `">
                       <td>
                           ` + i + `
                       </td>
                       <td style="text-align: justify;font-size: 9px;">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td> 
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_6) + `
                       </td>
                        <td class="borda-limit ` + element.co_6 + `">
                            ` + this.isNull(element.mfd_6) + `
                       </td>
                       
                      
                      
   
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_7) + `
                       </td>                       
                        <td class="borda-limit ` + element.co_7 + `">
                            ` + this.isNull(element.mfd_7) + `
                       </td>                       
                      
   
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = ` 
      <html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
    .zebr{ background-color: #DCDCDC;}
      td.ex2 { width:10%  }
      table.ex1 { margin: 0px 10px 10px 0px; }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
   table tr.heading td {
     text-align: center;
     font-size:7px;
     height: 10px;
     width: 1%;
}
   table tr.footer td {
     border: 0;
     text-align: center;
     font-size:12px;
}
table tr.pre td {
     text-align: center;
     font-size:10px;
}
table tr.bodyText td {
     text-align: center;
     font-size:8px;
}
table tr.cabecalho td {
     text-align: center;
     font-size:14px;
}
table tr.cabecalho2 td {
     text-align: justify;
     font-size:12px;
}
table tr.tablehead td {
     text-align: center;
     font-size:9px;
}
   .borda-limit{
     border-right-color:black;
     border-right-width: 1px;
   }
   body { font-family: Arial, Helvetica, sans-serif; }
   div { font-family: Arial, Helvetica, sans-serif; }
   table { font-family: Arial, Helvetica, sans-serif; }
           </style>
       </head>
       <body>
<div><br>
<table width="100%" BORDER=0 cellspacing="0" >
   <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
   <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral I.T.S.L</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>Francisca Manuela Manjenje Boavida</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>"Enfermeira Especialista"</td></tr>
            </table>
     <table width="100%" border="0" cellpadding="0" cellspacing="0">   
          <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
          <tr class="cabecalho"><td>INSTITUTO TÉCNICO PRIVADO DE SAÚDE</td></tr>
          <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
          <tr class="cabecalho"><td> PAUTA FINAL DE ` + dados[0].curso + `</td></tr>
     </table><br>

     <table width="100%" border="0" cellpadding="0" cellspacing="0">
            <tr class="cabecalho2">
              <td align="left">CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;</td>
              <td align="center">Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp; </td>
               <td align="center">TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u></td>
                   </tr>
             </table><br>

             <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
                
                  <tr class="tablehead">
                  <td rowspan="2" width="1%">Nº</td>
                  <td rowspan="2" class="ex2">Nome </td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[0].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[4].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                  <td width="3%"> </td>
     </tr>
     <tr class="heading">
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                     <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                        <td>
                      Resultado
                       </td>        
                   </tr>
                   ` + htmlDasNotas + `
</table><br>

   <table width="100%" cellspacing="0" >
   <tr>
     <td></td>
       <td>O(A) Cordenador(a) do Curso</td>
       <td> O(A) subdirector(a) Pedagógico(a)</td>
       <td> O(A) Director(a) da Escola </td>
       <td></td>
      <tr class="footer">
          <td></td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td></td>
          </tr>
            </table>
  </div>
      </body>
  </html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta9 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '7mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
           <tr class="bodyText ` + this.zebraPauta(i) + `">
                       <td>
                           ` + i + `
                       </td>
                       <td style="text-align: justify;font-size: 9px;">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td> 
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_6) + `
                       </td>
                        <td class="borda-limit ` + element.co_6 + `">
                            ` + this.isNull(element.mfd_6) + `
                       </td>
                       
                      
                      
   
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_7) + `
                       </td>                       
                        <td class="borda-limit ` + element.co_7 + `">
                            ` + this.isNull(element.mfd_7) + `
                       </td>
                       
                      
                  
                        <td>
                            ` + this.isNull(element.md_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_8) + `
                       </td>
                       <td class="borda-limit ` + element.co_8 + `">
                            ` + this.isNull(element.mfd_8) + `
                       </td>
                       
   
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = ` 
      <html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
    .zebr{ background-color: #DCDCDC;}
      td.ex2 { width:10%  }
      table.ex1 { margin: 0px 10px 10px 0px; }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
   table tr.heading td {
     text-align: center;
     font-size:7px;
     height: 10px;
     width: 1%;
}
   table tr.footer td {
     border: 0;
     text-align: center;
     font-size:12px;
}
table tr.pre td {
     text-align: center;
     font-size:10px;
}
table tr.bodyText td {
     text-align: center;
     font-size:8px;
}
table tr.cabecalho td {
     text-align: center;
     font-size:14px;
}
table tr.cabecalho2 td {
     text-align: justify;
     font-size:12px;
}
table tr.tablehead td {
     text-align: center;
     font-size:9px;
}
   .borda-limit{
     border-right-color:black;
     border-right-width: 1px;
   }
   body { font-family: Arial, Helvetica, sans-serif; }
   div { font-family: Arial, Helvetica, sans-serif; }
   table { font-family: Arial, Helvetica, sans-serif; }
           </style>
       </head>
       <body>
<div><br>
<table width="100%" BORDER=0 cellspacing="0" >
   <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
   <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral I.T.S.L</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>Francisca Manuela Manjenje Boavida</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>"Enfermeira Especialista"</td></tr>
            </table>
     <table width="100%" border="0" cellpadding="0" cellspacing="0">   
          <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
          <tr class="cabecalho"><td>INSTITUTO TÉCNICO PRIVADO DE SAÚDE</td></tr>
          <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
          <tr class="cabecalho"><td> PAUTA FINAL DE ` + dados[0].curso + `</td></tr>
     </table><br>

     <table width="100%" border="0" cellpadding="0" cellspacing="0">
            <tr class="cabecalho2">
              <td align="left">CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;</td>
              <td align="center">Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp; </td>
               <td align="center">TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u></td>
                   </tr>
             </table><br>

             <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
                
                  <tr class="tablehead">
                  <td rowspan="2" width="1%">Nº</td>
                  <td rowspan="2" class="ex2">Nome </td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[0].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[4].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[8].disciplina + `</td>
                   <td width="3%"> </td>
     </tr>
     <tr class="heading">   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                     <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                        <td>
                      Resultado
                       </td>        
                   </tr>
                   ` + htmlDasNotas + `
</table><br>

   <table width="100%" cellspacing="0" >
   <tr>
     <td></td>
       <td>O(A) Cordenador(a) do Curso</td>
       <td> O(A) subdirector(a) Pedagógico(a)</td>
       <td> O(A) Director(a) da Escola </td>
       <td></td>
      <tr class="footer">
          <td></td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td></td>
          </tr>
            </table>
  </div>
      </body>
  </html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta10 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '7mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
            <tr class="bodyText ` + this.zebraPauta(i) + `">
                       <td>
                           ` + i + `
                       </td>
                       <td style="text-align: justify;font-size: 9px;">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td> 
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_6) + `
                       </td>
                        <td class="borda-limit ` + element.co_6 + `">
                            ` + this.isNull(element.mfd_6) + `
                       </td>
                       
                      
                      
   
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_7) + `
                       </td>                       
                        <td class="borda-limit ` + element.co_7 + `">
                            ` + this.isNull(element.mfd_7) + `
                       </td>
                       
                      
                  
                        <td>
                            ` + this.isNull(element.md_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_8) + `
                       </td>
                       <td class="borda-limit ` + element.co_8 + `">
                            ` + this.isNull(element.mfd_8) + `
                       </td>
                       
   
   
    
                       <td>
                            ` + this.isNull(element.md_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_9) + `
                       </td>                     
                       <td class="borda-limit ` + element.co_9 + `">
                            ` + this.isNull(element.mfd_9) + `
                       </td>
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = ` 
      <html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
    .zebr{ background-color: #DCDCDC;}
      td.ex2 { width:10%  }
      table.ex1 { margin: 0px 10px 10px 0px; }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
   table tr.heading td {
     text-align: center;
     font-size:7px;
     height: 10px;
     width: 1%;
}
   table tr.footer td {
     border: 0;
     text-align: center;
     font-size:12px;
}
table tr.pre td {
     text-align: center;
     font-size:10px;
}
table tr.bodyText td {
     text-align: center;
     font-size:8px;
}
table tr.cabecalho td {
     text-align: center;
     font-size:14px;
}
table tr.cabecalho2 td {
     text-align: justify;
     font-size:12px;
}
table tr.tablehead td {
     text-align: center;
     font-size:9px;
}
   .borda-limit{
     border-right-color:black;
     border-right-width: 1px;
   }
   body { font-family: Arial, Helvetica, sans-serif; }
   div { font-family: Arial, Helvetica, sans-serif; }
   table { font-family: Arial, Helvetica, sans-serif; }
           </style>
       </head>
       <body>
<div><br>
<table width="100%" BORDER=0 cellspacing="0" >
   <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
   <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral I.T.S.L</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>Francisca Manuela Manjenje Boavida</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>"Enfermeira Especialista"</td></tr>
            </table>
     <table width="100%" border="0" cellpadding="0" cellspacing="0">   
          <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
          <tr class="cabecalho"><td>INSTITUTO TÉCNICO PRIVADO DE SAÚDE</td></tr>
          <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
          <tr class="cabecalho"><td> PAUTA FINAL DE ` + dados[0].curso + `</td></tr>
     </table><br>

     <table width="100%" border="0" cellpadding="0" cellspacing="0">
            <tr class="cabecalho2">
              <td align="left">CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;</td>
              <td align="center">Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp; </td>
               <td align="center">TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u></td>
                   </tr>
             </table><br>

             <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
                
                  <tr class="tablehead">
                  <td rowspan="2" width="1%">Nº</td>
                  <td rowspan="2" class="ex2">Nome </td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[0].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[4].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[8].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[9].disciplina + `</td>
                  <td width="3%"> </td>
     </tr>
     <tr class="heading">
   
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                     <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                        <td>
                      Resultado
                       </td>        
                   </tr>
                   ` + htmlDasNotas + `
</table><br>

   <table width="100%" cellspacing="0" >
   <tr>
     <td></td>
       <td>O(A) Cordenador(a) do Curso</td>
       <td> O(A) subdirector(a) Pedagógico(a)</td>
       <td> O(A) Director(a) da Escola </td>
       <td></td>
      <tr class="footer">
          <td></td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td></td>
          </tr>
            </table>
  </div>
      </body>
  </html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta11 (dados, notas) {
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '12mm' },
        'footer': {
          'height': '5mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
           <tr class="bodyText ` + this.zebraPauta(i) + `">
                       <td>
                           ` + i + `
                       </td>
                       <td style="text-align: justify;font-size: 9px;">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td> 
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_6) + `
                       </td>
                        <td class="borda-limit ` + element.co_6 + `">
                            ` + this.isNull(element.mfd_6) + `
                       </td>
                       
                      
                      
   
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_7) + `
                       </td>                       
                        <td class="borda-limit ` + element.co_7 + `">
                            ` + this.isNull(element.mfd_7) + `
                       </td>
                       
                      
                  
                        <td>
                            ` + this.isNull(element.md_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_8) + `
                       </td>
                       <td class="borda-limit ` + element.co_8 + `">
                            ` + this.isNull(element.mfd_8) + `
                       </td>
                       
   
   
    
                       <td>
                            ` + this.isNull(element.md_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_9) + `
                       </td>                     
                       <td class="borda-limit ` + element.co_9 + `">
                            ` + this.isNull(element.mfd_9) + `
                       </td>
   
   
                       <td>
                            ` + this.isNull(element.md_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_10) + `
                       </td>
                       <td class="borda-limit ` + element.co_10 + `">
                            ` + this.isNull(element.mfd_10) + `
                       </td>
   
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = ` 
      <html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
    .zebr{ background-color: #DCDCDC;}
      td.ex2 { width:10%  }
      table.ex1 { margin: 0px 10px 10px 0px; }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
   table tr.heading td {
     text-align: center;
     font-size:7px;
     height: 10px;
     width: 1%;
}
   table tr.footer td {
     border: 0;
     text-align: center;
     font-size:12px;
}
table tr.pre td {
     text-align: center;
     font-size:10px;
}
table tr.bodyText td {
     text-align: center;
     font-size:8px;
}
table tr.cabecalho td {
     text-align: center;
     font-size:14px;
}
table tr.cabecalho2 td {
     text-align: justify;
     font-size:12px;
}
table tr.tablehead td {
     text-align: center;
     font-size:9px;
}
   .borda-limit{
     border-right-color:black;
     border-right-width: 1px;
   }
   body { font-family: Arial, Helvetica, sans-serif; }
   div { font-family: Arial, Helvetica, sans-serif; }
   table { font-family: Arial, Helvetica, sans-serif; }
           </style>
       </head>
       <body>
<div><br>
<table width="100%" BORDER=0 cellspacing="0" >
   <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
   <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral I.T.S.L</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>Francisca Manuela Manjenje Boavida</td></tr>
   <tr class="pre"><td width="80%"> </td> <td>"Enfermeira Especialista"</td></tr>
            </table>
     <table width="100%" border="0" cellpadding="0" cellspacing="0">   
          <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
          <tr class="cabecalho"><td>INSTITUTO TÉCNICO PRIVADO DE SAÚDE</td></tr>
          <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
          <tr class="cabecalho"><td> PAUTA FINAL DE ` + dados[0].curso + `</td></tr>
     </table><br>

     <table width="100%" border="0" cellpadding="0" cellspacing="0">
            <tr class="cabecalho2">
              <td align="left">CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;</td>
              <td align="center">Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp; </td>
               <td align="center">TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;</td>
               <td>ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u></td>
                   </tr>
             </table><br>

             <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
                
                  <tr class="tablehead">
                  <td rowspan="2" width="1%">Nº</td>
                  <td rowspan="2" class="ex2">Nome </td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[0].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[4].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                   <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[8].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit" bgcolor="#DCDCDC">` + dados[9].disciplina + `</td>
                  <td align="center" colspan="4" class="borda-limit"  bgcolor="#DCDCDC">` + dados[10].disciplina + `</td>
                  <td width="3%"> </td>
     </tr>
     <tr class="heading">
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
   
   
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                     <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       
                      <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                       
                       <td>MT1</td>
                       <td> MT2</td>
                       <td> MT3</td>
                       <td class="borda-limit">CFD</td>
                        <td>
                      Resultado
                       </td>        
                   </tr>
                   ` + htmlDasNotas + `
</table><br>

   <table width="100%" cellspacing="0" >
   <tr>
     <td></td>
       <td>O(A) Cordenador(a) do Curso</td>
       <td> O(A) subdirector(a) Pedagógico(a)</td>
       <td> O(A) Director(a) da Escola </td>
       <td></td>
      <tr class="footer">
          <td></td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td>_____________________________________________________</td>
          <td></td>
          </tr>
            </table>
  </div>
      </body>
  </html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta12 (dados, notas) {
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '5mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
           <tr class="` + this.zebraPauta(i) + `">
                       <td align="center" height="20" style="font-size:8px">
                           ` + i + `
                       </td>
                       <td style="font-size:8px">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_0) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_1) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_1) + `
                       </td>  
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_2) + `
                       </td>
                        <td 
                            ` + this.isNull(element.rec_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_3) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_4) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_5) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_6) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_6) + `
                       </td>
                        <td class="borda-limit ` + element.co_6 + `">
                            ` + this.isNull(element.mfd_6) + `
                       </td>
                       
                      
                      
   
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_7) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_7) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_7) + `
                       </td>
                        <td class="borda-limit ` + element.co_7 + `">
                            ` + this.isNull(element.mfd_7) + `
                       </td>
                       
                      
                  
                        <td>
                            ` + this.isNull(element.md_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_8) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_8) + `
                       </td>
                       <td class="borda-limit ` + element.co_8 + `">
                            ` + this.isNull(element.mfd_8) + `
                       </td>
                       
   
   
    
                       <td>
                            ` + this.isNull(element.md_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.rec_9) + `
                       </td>
                       <td class="borda-limit ` + element.co_9 + `">
                            ` + this.isNull(element.mfd_9) + `
                       </td>
   
   
                       <td>
                            ` + this.isNull(element.md_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_10) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_10) + `
                       </td>
                        <td>
                            ` + this.isNull(element.rec_10) + `
                       </td>
                       <td class="borda-limit ` + element.co_10 + `">
                            ` + this.isNull(element.mfd_10) + `
                       </td>
   
   
                      <td>
                            ` + this.isNull(element.md_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_11) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.rec_11) + `
                       </td>
                       <td class="borda-limit ` + element.co_11 + `">
                            ` + this.isNull(element.mfd_11) + `
                       </td>
   
   
   
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = `<html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
             
    .zebr{
           background-color: #DCDCDC;
       }
   tfoot.report-footer {
         display:table-footer-group;
   }
             
      table.ex1 {
     margin:1;
     font-family: "Andale Mono, monospace";
     font-size:5px;
   }
     td.ex2 {
     width: 7px;
     padding:50px;
     _width: 50px;
        }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
        .zebr{
           background-color: #DCDCDC;
       }
   .9{
        color:red
   }
       #t1 {
     -moz-tab-size: 50;
     -o-tab-size: 50;
     tab-size: 50;
   }
   pre {
     display: block;
     font-family: "Andale Mono, monospace";
     white-space: pre;
   }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   
   .row-item:nth-child(20n) {
       page-break-after: always;
       page-break-inside: avoid;
   }
   
           </style>
       </head>
       <body>
       <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
              <span style="padding-left:90px">Visto</span><br>
          _________________________________
             <span style="padding-left:70px;">Director(a) Geral</span>
             </pre>
   
           <div align="center">
   
               <table border="0" cellpadding="0" cellspacing="0">
   
                   <tr>
   
                       <td colspan="4">
                         <center>  <img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" />
                  <br></br><center style="font-size:12px">INSTITUTO TÉCNICO PRIVADO DE SAÚDE <br>
                             ` + this.descricaoEscola() + `<br><br>
                              PAUTA FINAL DE ` + dados[0].curso + `</center>
                       </td>
                   </tr>
                     </table>
           </div>
           <div align="center">
           <table style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
            <tr class="heading">
                       <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                     CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                        <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                         PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                        ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                       </td>
                   </tr>
             </table>
             </div>
               </table>
   
             <div >
   
               <table style="width:5%"  BORDER=1 cellspacing="0" class="ex1" class="row-item">
                  <thead>
                  <tr class="heading">
                  <td rowspan="2">Nº</td>
                  <td rowspan="2" width="50px" class="ex2">Nome </td>
                  <td align="center" class="borda-limit" colspan="7"  bgcolor="#DCDCDC">` + dados[0].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"  bgcolor="#DCDCDC">` + dados[4].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                   <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                   <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[8].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[9].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"  bgcolor="#DCDCDC">` + dados[10].disciplina + `</td>
                  <td align="center" class="borda-limit" colspan="7"   bgcolor="#DCDCDC">` + dados[11].disciplina + `</td>
                  <td colspan="1"  height="80" > </td>
     </tr>
         <tr   class="heading">
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                        <td class="borda-limit">
                          MF
                       </td>
   
   
   
   
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                   <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>          
                        <td>
                      Resultado
                       </td>              
                   </tr>
                  </thead>
                  ` + htmlDasNotas + `
                   </table>
             </div>
         
            <footer>
   
    <table  class="ex1" BORDER=0 cellspacing="0">
    <tr>
        <td>
           <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
            <span>_____________________________________________________</span>
       </td>
        <td>
          <div><span style="padding-left:300px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
       </td>
        <td>
           <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
           <span style="padding-left:280px;"> _____________________________________________________</span>
       </td>
    </tr>
             </table>
   
   </footer>
       </body>
   </html>`
      this.pautasgerarpdf(options)
    },

    comporHtmlPauta13 (dados, notas) {
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '5mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
           <tr class="` + this.zebraPauta(i) + `">
                       <td align="center" height="20" style="font-size:8px">
                           ` + i + `
                       </td>
                       <td style="font-size:5px">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_0) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_1) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_1) + `
                       </td>  
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_2) + `
                       </td>
                        <td 
                            ` + this.isNull(element.rec_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_3) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_4) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_5) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_6) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_6) + `
                       </td>
                        <td class="borda-limit ` + element.co_6 + `">
                            ` + this.isNull(element.mfd_6) + `
                       </td>
                       
                      
                      
   
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_7) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_7) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_7) + `
                       </td>
                        <td class="borda-limit ` + element.co_7 + `">
                            ` + this.isNull(element.mfd_7) + `
                       </td>
                       
                      
                  
                        <td>
                            ` + this.isNull(element.md_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_8) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_8) + `
                       </td>
                       <td class="borda-limit ` + element.co_8 + `">
                            ` + this.isNull(element.mfd_8) + `
                       </td>
                       
   
   
    
                       <td>
                            ` + this.isNull(element.md_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.rec_9) + `
                       </td>
                       <td class="borda-limit ` + element.co_9 + `">
                            ` + this.isNull(element.mfd_9) + `
                       </td>
   
   
                       <td>
                            ` + this.isNull(element.md_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_10) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_10) + `
                       </td>
                        <td>
                            ` + this.isNull(element.rec_10) + `
                       </td>
                       <td class="borda-limit ` + element.co_10 + `">
                            ` + this.isNull(element.mfd_10) + `
                       </td>
   
   
                      <td>
                            ` + this.isNull(element.md_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_11) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.rec_11) + `
                       </td>
                       <td class="borda-limit ` + element.co_11 + `">
                            ` + this.isNull(element.mfd_11) + `
                       </td>
   
                       
   
                        <td>
                            ` + this.isNull(element.md_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_12) + `
                       </td>
                        <td>
                            ` + this.isNull(element.rec_12) + `
                       </td>
                       <td class="borda-limit ` + element.co_12 + `">
                            ` + this.isNull(element.mfd_12) + `
                       </td>
   
   
   
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = `<html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
             
    .zebr{
           background-color: #DCDCDC;
       }
   tfoot.report-footer {
         display:table-footer-group;
   }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   
             
      table.ex1 {
     margin:1;
     font-family: "Andale Mono, monospace";
     font-size:5px;
   }
     td.ex2 {
     width: 7px;
     padding:30px;
     _width: 50px;
        }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
        .zebr{
           background-color: #DCDCDC;
       }
   .9{
        color:red
   }
       #t1 {
     -moz-tab-size: 50;
     -o-tab-size: 50;
     tab-size: 50;
   }
   pre {
     display: block;
     font-family: "Andale Mono, monospace";
     white-space: pre;
   }
   .row-item:nth-child(20n) {
       page-break-after: always;
       page-break-inside: avoid;
   }
   
           </style>
       </head>
       <body>
       <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
              <span style="padding-left:90px">Visto</span><br>
          _________________________________
             <span style="padding-left:70px;">Director(a) Geral</span>
             </pre>
   
           <div align="center">
   
               <table border="0" cellpadding="0" cellspacing="0">
   
                   <tr>
   
                       <td colspan="4">
                         <center>  <img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" />
                  <br></br><center style="font-size:12px">INSTITUTO TÉCNICO PRIVADO DE SAÚDE <br>
                             ` + this.descricaoEscola() + `<br><br>
                              PAUTA FINAL DE ` + dados[0].curso + `</center>
   
                       </td>
                   </tr>
                     </table>
           </div>
           <div align="center">
           <table style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
            <tr class="heading">
                       <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                     CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                        <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                         PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                        ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                       </td>
                   </tr>
             </table>
             </div>
               </table>
   
             <div >
   
               <table style="width:5%"  BORDER=1 cellspacing="0" class="ex1" class="row-item">
                  <thead>
                  <tr class="heading">
                  <td rowspan="2" style="font-size:8px">Nº</td>
                  <td rowspan="2" width="10px" class="ex2" style="font-size:8px">Nome </td>
                  <td align="center" colspan="7" class="borda-limit"  bgcolor="#DCDCDC" style="font-size:8px">` + dados[0].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[1].disciplina + `</td>
                   <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[2].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[3].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"  bgcolor="#DCDCDC" style="font-size:8px">` + dados[4].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[5].disciplina + `</td>
                   <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[6].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[7].disciplina + `</td>
                   <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[8].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[9].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"  bgcolor="#DCDCDC" style="font-size:8px">` + dados[10].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[11].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC" style="font-size:8px">` + dados[12].disciplina + `</td>
                  <td colspan="1"  height="80" > </td>
     </tr>
         <tr   class="heading">
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                   <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
                       
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>   
                       
                       
   
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                        <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>       
                       
                       
   
                        <td>
                      Resultado
                       </td>              
                   </tr>
                  </thead>
                  ` + htmlDasNotas + `
                   </table>
             </div>
         
            <footer>
   
    <table  class="ex1" BORDER=0 cellspacing="0">
    <tr>
        <td>
           <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
            <span>_____________________________________________________</span>
       </td>
        <td>
          <div><span style="padding-left:300px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
       </td>
        <td>
           <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
           <span style="padding-left:280px;"> _____________________________________________________</span>
       </td>
    </tr>
             </table>
   
   </footer>
       </body>
   </html>`
      this.pautasgerarpdf(options)
    },

    comporHtmlPauta14 (dados, notas) {
      console.log(notas)
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '5mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
           <tr class="` + this.zebraPauta(i) + `">
                       <td align="center" height="20" style="font-size:8px">
                           ` + i + `
                       </td>
                       <td style="font-size:8px">
                            ` + element.nome + `
                       </td>
                       <td>
                            ` + this.isNull(element.md_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_0) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_0) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_0) + `
                       </td>
                       <td class="borda-limit ` + element.co_0 + `">
                            ` + this.isNull(element.mfd_0) + `
                       </td>
                       
                       
                        
   
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_1) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_1) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_1) + `
                       </td>  
                        <td class="borda-limit ` + element.co_1 + `">
                            ` + this.isNull(element.mfd_1) + `
                       </td>
                      
                      
                          
   
   
                        <td>
                            ` + this.isNull(element.md_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_2) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_2) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_2) + `
                       </td>
                        <td 
                            ` + this.isNull(element.rec_2) + `
                       </td>
                        <td class="borda-limit ` + element.co_2 + `">
                            ` + this.isNull(element.mfd_2) + `
                       </td>
                       
                      
                      
   
   
   
   
                         <td>
                            ` + this.isNull(element.md_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_3) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_3) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_3) + `
                       </td>
                        <td class="borda-limit ` + element.co_3 + `">
                            ` + this.isNull(element.mfd_3) + `
                       </td>
                       
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_4) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_4) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_4) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_4) + `
                       </td>
                        <td class="borda-limit ` + element.co_4 + `">
                            ` + this.isNull(element.mfd_4) + `
                       </td>
                       
                      
                       
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_5) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_5) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_5) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_5) + `
                       </td>
                        <td class="borda-limit ` + element.co_5 + `">
                            ` + this.isNull(element.mfd_5) + `
                       </td>
                      
                      
                       
   
   
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_6) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_6) + `
                       </td>
                        <td >
                            ` + this.isNull(element.rec_6) + `
                       </td>
                        <td class="borda-limit ` + element.co_6 + `">
                            ` + this.isNull(element.mfd_6) + `
                       </td>
                       
                      
                      
   
   
   
   
   
   
                       <td>
                            ` + this.isNull(element.md_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_7) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_7) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_7) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_7) + `
                       </td>
                        <td class="borda-limit ` + element.co_7 + `">
                            ` + this.isNull(element.mfd_7) + `
                       </td>
                       
                      
                  
                        <td>
                            ` + this.isNull(element.md_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_8) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_8) + `
                       </td>
                       <td >
                            ` + this.isNull(element.rec_8) + `
                       </td>
                       <td class="borda-limit ` + element.co_8 + `">
                            ` + this.isNull(element.mfd_8) + `
                       </td>
                       
   
   
    
                       <td>
                            ` + this.isNull(element.md_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_9) + `
                       </td>
                       <td>
                            ` + this.isNull(element.rec_9) + `
                       </td>
                       <td class="borda-limit ` + element.co_9 + `">
                            ` + this.isNull(element.mfd_9) + `
                       </td>
   
   
                       <td>
                            ` + this.isNull(element.md_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_10) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_10) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_10) + `
                       </td>
                        <td>
                            ` + this.isNull(element.rec_10) + `
                       </td>
                       <td class="borda-limit ` + element.co_10 + `">
                            ` + this.isNull(element.mfd_10) + `
                       </td>
   
   
                      <td>
                            ` + this.isNull(element.md_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_11) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_11) + `
                       </td>
                       <td>
                            ` + this.isNull(element.rec_11) + `
                       </td>
                       <td class="borda-limit ` + element.co_11 + `">
                            ` + this.isNull(element.mfd_11) + `
                       </td>
   
                       
   
                        <td>
                            ` + this.isNull(element.md_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.mf_12) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_12) + `
                       </td>
                        <td>
                            ` + this.isNull(element.rec_12) + `
                       </td>
                       <td class="borda-limit ` + element.co_12 + `">
                            ` + this.isNull(element.mfd_12) + `
                       </td>
   
   
   
   
                        <td>
                            ` + this.isNull(element.md_13) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m2_13) + `
                       </td>
                       <td>
                            ` + this.isNull(element.m3_13) + `
                       </td>
                       <td >
                            ` + this.isNull(element.mf_13) + `
                       </td>
                       <td>
                            ` + this.isNull(element.pg_13) + `
                       </td>
                       <td>
                            ` + this.isNull(element.rec_13) + `
                       </td>
                       <td class="borda-limit ` + element.co_13 + `">
                            ` + this.isNull(element.mfd_13) + `
                       </td>
   
   
   
                        <td class="NaoTransita" >
                        <spa class=` + element.resultado + `>  ` + element.resultado + `</spa>
                         </td> 
                   </tr>`
      })
      this.html = `<html>
       <head>
           <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
           <style>
   
             
    .zebr{
           background-color: #DCDCDC;
       }
   tfoot.report-footer {
         display:table-footer-group;
   }
             
      table.ex1 {
     margin:1;
     font-family: "Andale Mono, monospace";
     font-size:5px;
   }
   .borda-limit{
     border-right-color:black;
     border-right-width: 2px;
   }
   
     td.ex2 {
     width: 7px;
     padding:50px;
     _width: 50px;
        }
   .NaoTransita{
           color: red
       }
   .Transita{
           color: blue
       }
        .zebr{
           background-color: #DCDCDC;
       }
   .9{
        color:red
   }
       #t1 {
     -moz-tab-size: 50;
     -o-tab-size: 50;
     tab-size: 50;
   }
   pre {
     display: block;
     font-family: "Andale Mono, monospace";
     white-space: pre;
   }
   .row-item:nth-child(20n) {
       page-break-after: always;
       page-break-inside: avoid;
   }
   
           </style>
       </head>
       <body>
       <pre id="t1" style="padding-left:800px; font: 12px Andale Mono, monospace;">                                                                                                                                                                                                                                                                                                                                           
              <span style="padding-left:90px">Visto</span><br>
          _________________________________
             <span style="padding-left:70px;">Director(a) Geral</span>
             </pre>
   
           <div align="center">
   
               <table border="0" cellpadding="0" cellspacing="0">
   
                   <tr>
   
                       <td colspan="4">
                         <center>  <img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" />
                  <br></br><center style="font-size:12px">INSTITUTO TÉCNICO PRIVADO DE SAÚDE <br>
                             ` + this.descricaoEscola() + `<br><br>
                              PAUTA FINAL DE ` + dados[0].curso + `</center>
   
                       </td>
                   </tr>
                     </table>
           </div>
           <div align="center">
           <table style="padding-top:18px;" border="0" cellpadding="0" cellspacing="0">
            <tr class="heading">
                       <td align="left" rowspan="1" style=" font: 10px Andale Mono, monospace;">
                     CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                        <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td align="center"  colspan="2"  style=" font: 10px Andale Mono, monospace;">
                         TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                         PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                       </td>
                       <td  style=" font: 10px Andale Mono, monospace;">
                        ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                       </td>
                   </tr>
             </table>
             </div>
               </table>
   
             <div >
   
               <table style="width:5%"  BORDER=1 cellspacing="0" class="ex1" class="row-item">
                  <thead>
                  <tr class="heading">
                  <td rowspan="2">Nº</td>
                  <td rowspan="2" width="50px" class="ex2">Nome </td>
                  <td align="center" colspan="7" class="borda-limit"  bgcolor="#DCDCDC">` + dados[0].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                   <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"  bgcolor="#DCDCDC">` + dados[4].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                   <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"  bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                   <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[8].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[9].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"  bgcolor="#DCDCDC">` + dados[10].disciplina + `</td>
                  <td align="center" colspan="7"  class="borda-limit"   bgcolor="#DCDCDC">` + dados[11].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[12].disciplina + `</td>
                  <td align="center" colspan="7" class="borda-limit"   bgcolor="#DCDCDC">` + dados[13].disciplina + `</td>
                  <td colspan="1"  height="80" > </td>
     </tr>
         <tr   class="heading">
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                   <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                     <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit" >
                          MF
                       </td>
   
   
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
                       
                       
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
                       
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>
   
   
   
                      <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>   
                       
                       
   
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>       
                       
                       
   
                       <td>
                          M1
                       </td>
                       <td>
                         M2
                       </td>
                       <td>
                          M3
                       </td>
                       <td>
                           MD
                       </td>
                        <td>
                           EX
                       </td>
                       <td>
                          RC
                       </td>
                       <td class="borda-limit">
                          MF
                       </td>          
   
   
   
   
                        <td>
                      Resultado
                       </td>              
                   </tr>
                  </thead>
                  ` + htmlDasNotas + `
                   </table>
             </div>
         
            <footer>
   
    <table  class="ex1" BORDER=0 cellspacing="0">
    <tr>
        <td>
           <span style="padding-left:20px; font-size:10px;">O Cordenador do Curso</span><br></br>
            <span>_____________________________________________________</span>
       </td>
        <td>
          <div><span style="padding-left:300px;font: 10px Andale Mono, monospace;" >Luanda, ` + help.presente_data() + `</span></div>
       </td>
        <td>
           <span style="padding-left:300px; font-size:10px;"> A sub-Directora Pedagógica</span><br></br>
           <span style="padding-left:280px;"> _____________________________________________________</span>
       </td>
    </tr>
             </table>
   
   </footer>
       </body>
   </html>`
      this.pautasgerarpdf(options)
    },

    isNull (notaPauta) {
      if (notaPauta) { return notaPauta } else return ''
    },
    async criarPdf (item) {
      this.isLoading = true
      const valor = {
        turma: item.pkTurma,
        ano: item.idAno_Academico
      }
      let camposPauta = {}
      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)
        if (this.disciplinas.length > 0) this.disciplinas = this.disciplinas[0]
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }
        } else

        if (this.disciplinas.length === 6) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            quant: 6
          }
        } else
        if (this.disciplinas.length === 8) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            quant: 8
          }
        } else
        if (this.disciplinas.length === 9) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            quant: 9
          }
        } else
        if (this.disciplinas.length === 10) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            quant: 10
          }
        } else
        if (this.disciplinas.length === 11) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            quant: 11
          }
        } else
        if (this.disciplinas.length === 12) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[11].iddisciplina,
            quant: 12
          }
        } else
        if (this.disciplinas.length === 13) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[11].iddisciplina,
            d12: this.disciplinas[12].iddisciplina,
            quant: 12
          }
        } else
        if (this.disciplinas.length === 14) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[11].iddisciplina,
            d12: this.disciplinas[12].iddisciplina,
            d13: this.disciplinas[13].iddisciplina,
            quant: 12
          }
        }
        this.notas = await axios
          .post('/pautageral', camposPauta)
          .then(res => res.data)
        if (this.disciplinas.length === 4) { this.comporHtmlPauta4(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 6) { this.comporHtmlPauta6(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 13) { this.comporHtmlPauta13(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 14) { this.comporHtmlPauta14(this.disciplinas, this.notas) }
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report_Pauta' })
          .then(res => res.data)

        // console.log(msg)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    },

    async save () {
      try {
        var params = {
          idCurso: this.editedItem.idCurso.idCurso,
          idAno_Academico: this.idclasse,
          descricao: this.$refs.myid.innerText,
          autor: '',
          periodo: this.editedItem.periodo.descricao
        }
      } catch (error) {

      }

      let turmajaexiste = this.turmas.filter(
        t => t.turmadescricao === this.$refs.myid.innerText
      )

      if (!turmajaexiste.length > 0) {
        try {
          let msg = await axios
            .post('/turmaInsertOne', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
        }
        let d = new Date()
        d = new Date(d.getTime() - 3000000)
        // eslint-disable-next-line camelcase
        let date_format_str = d.getFullYear().toString() + '-' + ((d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1).toString() : '0' + (d.getMonth() + 1).toString()) + '-' + (d.getDate().toString().length === 2 ? d.getDate().toString() : '0' + d.getDate().toString()) + ' ' + (d.getHours().toString().length === 2 ? d.getHours().toString() : '0' + d.getHours().toString()) + ':' + ((parseInt(d.getMinutes() / 5) * 5).toString().length === 2 ? (parseInt(d.getMinutes() / 5) * 5).toString() : '0' + (parseInt(d.getMinutes() / 5) * 5).toString()) + ':00'
        let v = {
          turmadescricao: this.$refs.myid.innerText,
          periodo: this.editedItem.periodo.descricao,
          curso: this.editedItem.idCurso.descricao,
          data_2: date_format_str
        }

        this.turmas.unshift(v)
        this.close()
      } else {
        this.$store.dispatch('textMessage', {
          msg: 'A turma já existe',
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
